<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <div class="label">人脸识别日志：</div>
        <Select v-model="search.userName" style="width: 15em" placeholder="选择用户"
          clearable>
          <Option v-for="(value, key) in  userList" :key="key" :value="key">{{ value }}</Option>
        </Select>
        <div class="label" style="margin-left: 10px;"> 识别时间：</div>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;"
          @on-change="dateSelect($event)"></DatePicker>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.fh {
  margin: 5px 0px;
  background-color: #489ae1;
  color: #FFF;
  font-weight: bold;
  border-radius: 3px;
  padding: .3rem;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.ivu-table-border {
  border-color: #CCC;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}

.form-row {
  display: flex;
  align-items: center;
}

.form-row Select,
.form-row i-input {
  margin-right: 10px;
  /* 可根据需要调整间距 */
}
</style>

<script>
import { BaseUrl } from '@/http/config.js';
import LoadImg from "../../../components/Load_img.vue";
import { timeStamp } from "../../../util/common/date";
import toolbar from "../toolBar.vue";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            title: "序号",
            key: "index",
            width: 80,
            align: "center"
          },
          {
            title: "设备名称",
            key: "sn",
            align: "center"
          },
          {
            title: "扫描日期",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.recogTime, "yyyy-MM-dd HH:mm:ss")
                ),
              ]);
            },
          },
          {
            title: "访客姓名",
            width: 220,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  //this.findNameByFaceId(params.row.realName)
                  params.row.realName || "陌生人"
                ),
              ]);
            }
          },
          {
            title: "人脸照片",
            key: "photo",
            align: "center",
            render(h, params) {
              return h(
                "div",
                {
                  style: {
                    height: "50px",
                    overflow: "hidden"
                  }
                },
                [
                  h("vImage", {
                    props: {
                      imgUrl: params.row.photo
                    }
                  })
                ]
              );
            }
          },
        ],
        tableBorder: "1px solid #CCC", // 设置边框颜色
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        userName: null,
        startDate: null,
        endDate: null,
      },
      userList: {}, // 登录过的用户列表Map
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
    };
  },
  components: {
    toolbar,
    LoadImg
  },
  created() {
    this.getUserEnum();
    this.getData(); // 数据初始化
  },
  methods: {
    // 搜索
    searchFunc() {
      this.getData();
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Waste.getFaceLogList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          // 给list数组中的每个元素添加index索引字段
          res.data.list.forEach((item, index) => {
            item.index = index + 1;
          });
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    // 获取FaceID枚举值
    getUserEnum() {
      this.$api.Waste.getFaceUserEnum({}, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.userList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取分组枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },
    // findNameByFaceId(faceId) {
    //   return Object.prototype.hasOwnProperty.call(this.userList, faceId) ? this.userList[faceId] : '陌生人';
    // },
  }
};
</script>